import ProjectPoleModel from 'models/ProjectPoleModel';
import BudgetAggregate  from 'models/budgetModels/BudgetAggregateModel';

export default class ProjectPoleBudgetModel extends BudgetAggregate(ProjectPoleModel) {
	static get path(): string {
		return '/project_poles/_budget';
	}
}
